import { CINEMATIC_ARCHETYPE } from './CinematicArchetype.js';
import { ROMANTIC_ARCHETYPE } from './RomanticArchetype.js';
import { BAROQUE_ARCHETYPE } from './BaroqueArchetype.js';
import { MEDIEVAL_ARCHETYPE } from './MedievalArchetype.js';
import { HORROR_ARCHETYPE } from './HorrorArchetype.js';
import { GOTHIC_ARCHETYPE } from './GothicArchetype.js';
import { MINIMALIST_ARCHETYPE } from './MinimalistArchetype.js';
import { IMPRESSIONIST_ARCHETYPE } from './ImpressionistArchetype.js';
import { ETHEREAL_ARCHETYPE } from './EtherealArchetype.js';
import { PASTORAL_ARCHETYPE } from './PastoralArchetype.js';
import { FANTASY_ARCHETYPE } from './FantasyArchetype.js';
import { CHRISTMAS_ARCHETYPE } from './ChristmasArchetype.js';
import { ACTION_ARCHETYPE } from './ActionArchetype.js';
import { WALTZ_ARCHETYPE } from './WaltzArchetype.js';
import { NEO_CLASSICAL_ARCHETYPE } from './NeoClassicalArchetype.js';
import { SCIFI_ARCHETYPE } from './SciFiArchetype.js';
import { CYBER_ORCH_ARCHETYPE } from './CyberOrchArchetype.js';
import { ROCK_ARCHETYPE } from './RockArchetype.js';
import { JAZZ_ARCHETYPE } from './JazzArchetype.js';
import { NOIRE_ARCHETYPE } from './NoireArchetype.js';
import { WESTERN_ARCHETYPE } from './WesternArchetype.js';
import { ELECTRONIC_ARCHETYPE } from './ElectronicArchetype.js';
import { AVANT_GARDE_ARCHETYPE } from './AvantGardeArchetype.js';

export const ArchetypeRegistry = {
    /**
     * Retrieves the statistical archetype for a given genre.
     * @param {string} genre - The harmony source / genre key.
     * @returns {Object|null} The archetype object or null if not found.
     */
    get(genre) {
        if (!genre) return null;

        const normalized = genre.toLowerCase();

        // --- NEW CATEGORIES ---

        if (normalized.includes('cyber') || normalized.includes('hybrid')) {
            return CYBER_ORCH_ARCHETYPE;
        }

        if (normalized.includes('sci') || normalized.includes('industrial')) {
            return SCIFI_ARCHETYPE;
        }

        if (normalized.includes('avant') || normalized.includes('experimental') || normalized.includes('atonal')) {
            return AVANT_GARDE_ARCHETYPE;
        }

        if (normalized.includes('rock') || normalized.includes('punk') || normalized.includes('metal') || normalized.includes('grunge') || normalized.includes('surf') || normalized.includes('indie')) {
            return ROCK_ARCHETYPE;
        }

        if (normalized.includes('noire') || normalized.includes('noir') || normalized.includes('dark jazz')) {
            return NOIRE_ARCHETYPE;
        }

        if (normalized.includes('jazz') || normalized.includes('swing') || normalized.includes('bop') || normalized.includes('fusion') || normalized.includes('soul') || normalized.includes('funk') || normalized.includes('blues')) {
            return JAZZ_ARCHETYPE;
        }

        if (normalized.includes('electronic') || normalized.includes('house') || normalized.includes('techno') || normalized.includes('trance') || normalized.includes('dubstep') || normalized.includes('synth') || normalized.includes('trap') || normalized.includes('lofi') || normalized.includes('idm') || normalized.includes('ambient') || normalized.includes('pop')) {
            return ELECTRONIC_ARCHETYPE;
        }

        // --- EXISTING CATEGORIES ---

        if (normalized.includes('western') || normalized.includes('americana') || normalized.includes('country')) {
            return WESTERN_ARCHETYPE;
        }

        if (normalized.includes('cinematic') || normalized.includes('epic') || normalized.includes('world')) {
            return CINEMATIC_ARCHETYPE;
        }

        if (normalized.includes('romantic') || normalized.includes('piano')) {
            return ROMANTIC_ARCHETYPE;
        }

        if (normalized.includes('neo-classical')) {
            return NEO_CLASSICAL_ARCHETYPE;
        }

        if (normalized.includes('medieval')) {
            return MEDIEVAL_ARCHETYPE;
        }

        if (normalized.includes('baroque') || normalized.includes('classical')) {
            return BAROQUE_ARCHETYPE;
        }

        if (normalized.includes('gothic')) {
            return GOTHIC_ARCHETYPE;
        }

        if (normalized.includes('horror') || normalized.includes('tension')) {
            return HORROR_ARCHETYPE;
        }

        if (normalized.includes('minimalist') || normalized.includes('pulsing')) {
            return MINIMALIST_ARCHETYPE;
        }

        if (normalized.includes('ethereal')) {
            return ETHEREAL_ARCHETYPE;
        }

        if (normalized.includes('impressionist')) {
            return IMPRESSIONIST_ARCHETYPE;
        }

        if (normalized.includes('pastoral')) {
            return PASTORAL_ARCHETYPE;
        }

        if (normalized.includes('waltz')) {
            return WALTZ_ARCHETYPE;
        }

        if (normalized.includes('christmas') || normalized.includes('holiday')) {
            return CHRISTMAS_ARCHETYPE;
        }

        if (normalized.includes('fantasy') || normalized.includes('adventure')) {
            return FANTASY_ARCHETYPE;
        }

        if (normalized.includes('action') || normalized.includes('chase') || normalized.includes('hybrid')) {
            return ACTION_ARCHETYPE;
        }

        return null;
    }
};
